<script lang="ts">
    import {onMount} from "svelte";
    import {listEmployees} from "$lib/calls/employee";
    import dayjs from "dayjs";
    import {Blockquote, Button, Heading, Input, Label, Modal, Textarea} from "flowbite-svelte";
    import CopyToClipboard from "$lib/components/CopyToClipboard.svelte";
    import type {Employee} from "$lib/types/employee";
    import EmployeeAvatar from "$lib/components/EmployeeAvatar.svelte";
    import {getUnits} from "$lib/calls/unit";
    import Steps from "$lib/components/Steps.svelte";
    import StatusTriggerButtons from "$items/employee/StatusTriggerButtons.svelte";
    import {post, put} from "$lib/api";

    let employees:Employee[] = [];
    let reminders = [];
    let open = false;
    let modalContent = {
        notes: '',
        completed: false
    }
    let units = []
    let step = 0

    let steps = [
        {
            text: 'Erreicht?',
            buttons: [
                {
                    text: 'Ja',
                    color: 'primary',
                    action: () => {
                        step = 1
                    }
                },{
                    text: 'Nein',
                    color: 'red',
                    action: () => {
                        open = false
                    }
                }
            ]
        },{
            text: 'Freundliche Begrüßung',
        },{
            text: 'Wie bist du auf uns aufmerksam geworden?',
            input: 'reference',
            type: 'text'
        },{
            text: 'Zum Ablauf: Du stellst dich vor, wir (REcrew) stellen uns vor, dann sprechen wir über nächste Schritte und Konditionen. Ok?',
        },{
            text: 'Aufforderung zur Vorstellung',
            input: 'notes',
            type: 'text'
        },{
            text: 'Wie alt bist du?',
            input: 'age',
            type: 'number'
        },{
            text: 'Hast du schon Erfahrung in Gastronomie oder woanders?',
            input: 'experience',
            type: 'text'
        },{
            text: 'Was machst Du derzeit, wie ist Dein Status – Schüler, Student, Azubi o. ä.?',
            input: 'status',
            type: 'text'
        },{
            text: 'Wie oft möchtest Du von Mo-So arbeiten? Gibt es zeitliche Einschränkungen?',
            input: 'daysPerWeek',
            type: 'text'
        },{
            text: 'Ab wann ist Einstieg möglich (Beginn immer Monats 1.)',
            input: 'startDate',
            type: 'date'
        },{
            text: 'Hast du noch andere vertragliche Beschäftigungen?',
            input: 'employment',
            type: 'text'
        },{
            text: 'Vorstellung REcrew: Personalvermittler für die Gastronomie in München,\n' +
                'Sitz in der Schellingstraße/Univiertel und weiteren\n' +
                'Standorten in D., derzeitiger Fokus Service.\n' +
                'Unsere Kunden sind Caterer und Hotels aus dem\n' +
                'gehobenen Segment (Beispiele).\n' +
                'Jobarten (Hotel: früh/spät Bar, Restaurants, Bankett;\n' +
                'Caterer: unterschiedl. Events wie Messe, Fußballspiele,\n' +
                'Firmen- und private VAs an unterschiedl. Locations).\n' +
                'Vermittlung über Terminal App.',
        },{
            text: 'Bewerberprozess: Get-to-know-Treffen (GTK) kurze\n' +
                'Ablaufbeschreibung.\n' +
                'Vorstellung des Village (Treffpunkt bei Schichten\n' +
                'außerhalb von MUC, Café fürs Team, Schulungsort und\n' +
                'Office).',
        },{
            text: 'Nächste Schritte - wie geht’s jetzt weiter:\n' +
                'Zusendung Stammdatenblatt zum Ausfüllen, dann folgt\n' +
                'Einladung zum GTK mit Auswahl an Terminen.\n' +
                'Nach GTK und beidseitigem positiven Eindruck folgt\n' +
                'Vertragsangebot durch Legal. (Erkl. Gehaltsmodell)\n' +
                'Nach Vertragsunterzeichnung folgen die Zugangsdaten\n' +
                'zur App, Einstiegsinfos und Anruf zur Vereinbarung der\n' +
                'ersten Einsätze durch Dispo.',
        },{
            text: 'Hast du noch offene Fragen?',
            input: 'question',
            type: 'text',

        },{
            text: 'Verabschiedung',
            buttons: [
                {
                    text: 'Abschließen',
                    color: 'primary',
                    action: () => {
                        finalizeInterview()
                    }
                }
            ]
        },
    ]


    const finalizeInterview = async () => {
        let html = '';
        steps.forEach(step => {
            if (step.input) {
                html += `<div class="mb-2"><p class="font-bold">${step.text}</p><p>${modalContent[step.input]}</p></div>`
            }
        })
        // TL-item
        await post(`/employee/${modalContent.employee.uuid}/timeline`, {
            content: html,
        })
        // remove reminder
        let reminder = reminders.find(x => x.employeeId === modalContent.employee.id)
        reminder.doneAt = dayjs().unix()
        await put(`/employee/${modalContent.employee.uuid}/reminder/${reminder.id}`, reminder)

        modalContent.completed = true

    }

    const openModal = (employee:Employee) => {
        step = 0
        modalContent = {employee, notes: '', completed: false}
        open = true
    }
    onMount(async () => {
        const call = await listEmployees({employmentStatus: 'telephone-interview', page: 1, pageSize: 100})
        employees = call.collection;
        reminders = employees.map(x => x.reminders.filter(y => y.note.includes(' | Telefontermin:'))).flat()
        units = await getUnits();
        console.log(reminders)
    })
</script>
<svelte:head>
    <title>Telefontermine</title>
</svelte:head>

{#each reminders.sort((a, b) => a.remindAt.stamp - b.remindAt.stamp) as reminder}
    {@const employee = employees.find(x => x.id === reminder.employeeId)}
    <div class="grid grid-cols-4 gap-3 items-center border-b pb-1">

        <div>{dayjs.unix(reminder.remindAt.stamp).format('DD.MM. HH:mm')} </div>
        <div>{employee.name} </div>
        <div class="flex gap-2"><a href="tel:{employee.mobile}">{employee.mobile}</a>
            <CopyToClipboard textToCopy={employee.mobile}/>
        </div>
        <div>
            <Button on:click={() => openModal(employee)} size="xs">Frageboden</Button>
        </div>
    </div>
{/each}
<Modal bind:open size="xl" title="{modalContent?.employee?.name}">
<div class="flex gap-3">
    <div class="grid gap-3 items-center border rounded p-3">
        <EmployeeAvatar size="2xl" employee={modalContent?.employee}/>
        <p>{units.find(x => x.id === modalContent?.employee?.unitId)?.name}</p>
        <pre class="w-full overflow-x-auto">{modalContent?.employee?.note || ''}</pre>
    </div>
    <div class="flex-1">
        {#if modalContent.completed}
            <StatusTriggerButtons employee={modalContent?.employee} />
            <div class="mt-5">
                <Button color="yellow" on:click={() => open = false}>Schließen</Button>
            </div>

        {:else}
            <div class="flex gap-3">
                <div class="flex-1">
                    <Heading tag="h3" customSize="text-xl">Telefoninterview</Heading>
                    <Blockquote border bg  size="xl" class="p-3">{steps[step].text}</Blockquote>
                    {#if steps[step].hasOwnProperty('input')}
                        <Label class="mt-5 space-y-2">
                            <span>Antwort</span>
                            <Input type={steps[step].type} bind:value={modalContent[steps[step].input]} />
                        </Label>

                    {/if}
                    <div class="flex gap-3 mt-5">

                        {#if steps[step].buttons}
                            {#each steps[step].buttons as button}
                                <Button color={button.color} on:click={button.action}>{button.text}</Button>
                            {/each}
                        {:else}
                            <Button on:click={() => step++}>Weiter</Button>
                        {/if}
                    </div>
                    <div class="flex gap-1 mt-8">
                        {#each steps as _, index}
                            <Button size="xs" on:click={() => step = index} color="{step === index ? 'primary' : 'secondary'}">{index + 1}</Button>
                        {/each}
                    </div>

                </div>

                <div>
                    <Heading tag="h3" customSize="text-xl">Notizen</Heading>
                    <Textarea rows="4" bind:value={modalContent.notes}/>

                </div>
            </div>
        {/if}




    </div>
</div>
</Modal>

